import { Modal, Button, Form, Dropdown, Row, Col } from 'react-bootstrap';
import { Formik, Field, FieldArray, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { shiftTimeSlots } from '../../helpers';

const EditShiftTypes = ({
  showShiftsModal,
  handleShiftsDisplay,
  handleUpdateShifts,
  exitingShifts,
}) => {
  const shiftsData =
    exitingShifts && exitingShifts.length > 0
      ? exitingShifts.map((shift) => {
          shift.status = null;
          return shift;
        })
      : [];
  const timeSlots = shiftTimeSlots();

  return (
    <>
      <Dropdown.Item
        onClick={() => {
          handleShiftsDisplay(true);
        }}
      >
        Edit shift names
      </Dropdown.Item>

      <Modal
        show={showShiftsModal}
        onHide={() => {
          handleShiftsDisplay(false);
        }}
        centered
        size="lg"
        backdropClassName="inner-modal-backdrop"
      >
        <Modal.Header>
          <Modal.Title className="m-0">Edit Shift Names</Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => {
              handleShiftsDisplay(false);
            }}
          />
        </Modal.Header>
        <Formik
          enableReinitialize
          initialValues={{
            shifts: shiftsData,
          }}
          validationSchema={Yup.object().shape({
            shifts: Yup.array().of(
              Yup.object().shape({
                name: Yup.string().required('Please enter a shift name'),
                shiftStart: Yup.string().when('status', {
                  is: (status) => status !== 'delete',
                  then: Yup.string()
                    .required('Please select a shift start time')
                    .matches(
                      /^([01]\d|2[0-3]):([0-5]\d)$/,
                      'Please enter shift time in HH:MM format'
                    ),
                  otherwise: Yup.string(),
                }),
                shiftEnd: Yup.string().when('status', {
                  is: (status) => status !== 'delete',
                  then: Yup.string()
                    .required('Please select a shift end time')
                    .matches(
                      /^([01]\d|2[0-3]):([0-5]\d)$/,
                      'Please enter shift time in HH:MM format'
                    ),
                  otherwise: Yup.string(),
                }),
              })
            ),
          })}
          onSubmit={(values) => {
            handleUpdateShifts(values);
          }}
        >
          {(formikprops) => (
            <Form onSubmit={formikprops.handleSubmit}>
              <Modal.Body
                style={{ maxHeight: 'calc(100vh - 210px)', overflowY: 'auto' }}
              >
                <FieldArray
                  name="shifts"
                  render={(arrayHelpers) => (
                    <div>
                      {formikprops.values.shifts &&
                        formikprops.values.shifts.length > 0 &&
                        formikprops.values.shifts.map((shift, index) => {
                          if (shift.status !== 'delete') {
                            return (
                              <Row key={index} className="mb-4">
                                <Col xs={5}>
                                  <Field
                                    className="form-control"
                                    type="text"
                                    placeholder="Shift name"
                                    name={`shifts.${index}.name`}
                                  />
                                  <ErrorMessage
                                    name={`shifts.${index}.name`}
                                    render={(msg) => (
                                      <small className="text-danger">
                                        {msg}
                                      </small>
                                    )}
                                  />
                                </Col>
                                <Col xs={3}>
                                  <Select
                                    name={`shifts.${index}.shiftStart`}
                                    options={timeSlots}
                                    className="basic-multi-select"
                                    placeholder="09:00"
                                    value={
                                      timeSlots.find(
                                        (option) =>
                                          option.value ===
                                          formikprops.values.shifts[index]
                                            .shiftStart
                                      ) || {
                                        label:
                                          formikprops.values.shifts[index]
                                            .shiftStart || 'Invalid time',
                                        value:
                                          formikprops.values.shifts[index]
                                            .shiftStart || '',
                                      }
                                    }
                                    onChange={(event) => {
                                      formikprops.setFieldValue(
                                        `shifts.${index}.shiftStart`,
                                        event.value
                                      );
                                      formikprops.setFieldTouched(
                                        `shifts.${index}.shiftStart`,
                                        true
                                      );
                                    }}
                                    onBlur={() =>
                                      formikprops.setFieldTouched(
                                        `shifts.${index}.shiftStart`,
                                        true
                                      )
                                    }
                                    theme={(theme) => ({
                                      ...theme,
                                      colors: {
                                        ...theme.colors,
                                        primary: '#0649b5',
                                        neutral10: '#edf2f9',
                                        neutral20: '#d2ddec',
                                        neutral30: '#d2ddec',
                                        neutral50: '#b1c2da',
                                        neutral80: '#12263f',
                                        dangerLight: '#DEEBFF',
                                        danger: '#12263f',
                                      },
                                    })}
                                  />
                                  <ErrorMessage
                                    name={`shifts.${index}.shiftStart`}
                                    render={(msg) => (
                                      <small className="text-danger">
                                        {msg}
                                      </small>
                                    )}
                                  />
                                </Col>
                                <Col xs={3}>
                                  <Select
                                    name={`shifts.${index}.shiftEnd`}
                                    options={timeSlots}
                                    className="basic-multi-select"
                                    placeholder="17:00"
                                    value={
                                      timeSlots.find(
                                        (option) =>
                                          option.value ===
                                          formikprops.values.shifts[index]
                                            .shiftEnd
                                      ) || {
                                        label:
                                          formikprops.values.shifts[index]
                                            .shiftEnd || 'Invalid time',
                                        value:
                                          formikprops.values.shifts[index]
                                            .shiftEnd || '',
                                      }
                                    }
                                    onChange={(event) => {
                                      formikprops.setFieldValue(
                                        `shifts.${index}.shiftEnd`,
                                        event.value
                                      );
                                      formikprops.setFieldTouched(
                                        `shifts.${index}.shiftEnd`,
                                        true
                                      );
                                    }}
                                    onBlur={() =>
                                      formikprops.setFieldTouched(
                                        `shifts.${index}.shiftEnd`,
                                        true
                                      )
                                    }
                                    theme={(theme) => ({
                                      ...theme,
                                      colors: {
                                        ...theme.colors,
                                        primary: '#0649b5',
                                        neutral10: '#edf2f9',
                                        neutral20: '#d2ddec',
                                        neutral30: '#d2ddec',
                                        neutral50: '#b1c2da',
                                        neutral80: '#12263f',
                                        dangerLight: '#DEEBFF',
                                        danger: '#12263f',
                                      },
                                    })}
                                  />
                                  <ErrorMessage
                                    name={`shifts.${index}.shiftEnd`}
                                    render={(msg) => (
                                      <small className="text-danger">
                                        {msg}
                                      </small>
                                    )}
                                  />
                                </Col>
                                <Col xs={1}>
                                  <Button
                                    variant="link"
                                    onClick={() =>
                                      formikprops.setFieldValue(
                                        `shifts.${index}.status`,
                                        'delete'
                                      )
                                    }
                                  >
                                    <i className="mdi mdi-window-close" />
                                  </Button>
                                </Col>
                              </Row>
                            );
                          }
                          return null;
                        })}
                      <div className="mb-4">
                        <Button
                          variant="outline-primary"
                          type="button"
                          onClick={() =>
                            arrayHelpers.push({
                              name: '',
                              shiftStart: '09:00',
                              shiftEnd: '17:00',
                              status: null,
                            })
                          }
                        >
                          Add Shift Name
                        </Button>
                      </div>
                    </div>
                  )}
                />
              </Modal.Body>
              <Modal.Footer className="d-flex justify-content-between">
                <Button
                  variant="link"
                  onClick={() => {
                    handleShiftsDisplay(false);
                  }}
                >
                  Cancel
                </Button>
                <Button variant="primary" type="submit">
                  Update
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

EditShiftTypes.propTypes = {
  showShiftsModal: PropTypes.bool,
  handleShiftsDisplay: PropTypes.func,
  handleUpdateShifts: PropTypes.func,
  exitingShifts: PropTypes.array,
};

export default EditShiftTypes;
